<!-- Topbar -->
<nav class="navbar nav-header navbar-expand navbar-light  topbar mb-2 static-top ">
  <div class="container">
    <div class="row" style="width: 100%;">
      <div class="col-lg-6 col-sm-6">
        <!-- Topbar Search -->
        <a href="https://www.berkleymarine.com">
          <img src="xps/assets/img/headerLogo.jpg" class="pl-4 headerImage"></a>
        <!-- Topbar Navbar -->
      </div>
      <div class="col-lg-6 col-sm-6">
        <ul class="navbar-nav ml-auto" style="float:right">
          <!-- Nav Item - User Information -->
          <li class="nav-item dropdown no-arrow">
            <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <span class="mr-2 d-lg-inline user_cls">Welcome, {{dao?.loginUserDetail?.given_name}}
                </span>
              <i class="fa fa-caret-down" aria-hidden="true"></i>
            </a>
            <!-- Dropdown - User Information -->
            <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
              <a class="dropdown-item" (click)="logout()">
                <!-- <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i> -->
                <i class="fa fa-sign-out mr-2 " aria-hidden="true"></i>
                Logout
              </a>
            </div>
          </li>
          <a class="agentCentralBtn" title="Agent Central" target="_blank" href="https://www.berkleymarine.com/agent-central/" id="userAgentCentral" role="button">
              <span class="agentCentralSpan">Agent Central</span>
            </a>
        </ul>
      </div>
    </div>
  </div>
</nav>

<div class="menu_header navbar-expand"
  [hidden]="currentPath==='/xps/unauthenticated' || currentPath==='/xps/overview' || currentPath==='/xps/login' || currentPath==='/xps/landing' || currentPath==='/xps/maintenance' || notification?.type==='SITEDOWN'">
  <div class="container">
    <ul class="navbar-nav ml-auto">


      <!-- Nav Item - User Information -->

      <li class="nav-item ">
        <a href="/xps/landing" class="nav-link">
          <span class="mr-2 d-lg-inline menu_link">XS Home</span>
        </a>
      </li>

      <li class="{{isBFMInternal?'nav-item nav-itemDisabled':'nav-item'}} ">
        <a href="/xps/search" class="{{isBFMInternal?'nav-link nav-linkDisabled':'nav-link'}}">
          <span class="{{isBFMInternal?'mr-2 d-lg-inline menu_link menuLabelDisabled':'mr-2 d-lg-inline menu_link '}}">View all Policies and Quotes</span>
        </a>
      </li>

      <li class="nav-item ">
        <a href="/xps/policyQuotes" (click)="policy('Manage a Policy')" class="nav-link">
          <span class="mr-2 d-lg-inline menu_link">Manage a Policy</span>
        </a>
      </li>

      <li class="nav-item ">
        <a href="/xps/reportclaim" class="nav-link">
          <span class="mr-2 d-lg-inline menu_link">Report a Claim</span>
        </a>
      </li>

      <li class="nav-item ">
        <a href="/xps/evidenceofinsurance" class="nav-link">
          <span class="mr-2 d-lg-inline menu_link">Request Evidence of Insurance</span>
        </a>
      </li>

      <li class="nav-item ">
        <a href="/xps/policyQuotes" (click)="policy('Cancel My Policy')" class="nav-link">
          <span class="mr-2 d-lg-inline menu_link">Cancel a Policy</span>
        </a>
      </li>
    </ul>
  </div>

</div>


<!-- End of Topbar -->